export default __webpack_public_path__ + "images/T6.c3f4177.png";